import apiClient from './apiClient'

export const getCustomers = async (params = {}) => {
  try {
    const response = await apiClient.get('/auth/customers/', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      },
      params
    })
    return response.data
  } catch (error) {
    console.error('Error en getCustomers:', error.response || error)
    throw new Error(error.response?.data?.message || 'Error al obtener la lista de clientes')
  }
}

export const getCustomerDetails = async (customerId) => {
  try {
    const response = await apiClient.get(`/auth/customers/${customerId}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al obtener los detalles del cliente')
  }
}

export const createCustomer = async (customerData) => {
  try {
    const response = await apiClient.post('/auth/customers/', customerData)
    return response.data
  } catch (error) {
    throw handleError(error)
  }
}

export const blockCustomer = async (customerId, adminNotes = '') => {
  try {
    const response = await apiClient.post(`/auth/customers/${customerId}/block/`, {
      admin_notes: adminNotes
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al bloquear el cliente')
  }
}

export const unblockCustomer = async (customerId, adminNotes = '') => {
  try {
    const response = await apiClient.post(`/auth/customers/${customerId}/unblock/`, {
      admin_notes: adminNotes
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al desbloquear el cliente')
  }
}

export const deleteCustomer = async (customerId) => {
  try {
    const response = await apiClient.delete(`/auth/customers/${customerId}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.detail || error.response?.data?.message || 'Error al eliminar el cliente')
  }
}

export const assignCustomerRoles = async (customerId, roles) => {
  try {
    const response = await apiClient.patch(`/auth/customers/${customerId}/assign-roles/`, { roles })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.detail || error.response?.data?.message || 'Error al asignar roles')
  }
}

export const setCustomerType = async (customerId, customerType) => {
  try {
    const response = await apiClient.patch(`/auth/customers/${customerId}/set-customer-type/`, { customer_type: customerType })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.detail || 'Error al cambiar tipo de cliente')
  }
}

export const approveDistributorRequest = async (customerId) => {
  try {
    const response = await apiClient.post(`/auth/customers/${customerId}/approve-distributor/`, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.detail || 'Error al aprobar mayorista')
  }
}

export const rejectDistributorRequest = async (customerId) => {
  try {
    const response = await apiClient.post(`/auth/customers/${customerId}/reject-distributor/`, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.error || error.response?.data?.detail || 'Error al rechazar solicitud')
  }
}

export const getCustomerOrders = async (customerId) => {
  try {
    const response = await apiClient.get(`/auth/customers/${customerId}/orders/`)
    return response.data
  } catch (error) {
    throw handleError(error)
  }
}

const handleError = (error) => {
  if (error.response) {
    const data = error.response.data
    if (data.detail) {
      throw new Error(data.detail)
    } else if (data.message) {
      throw new Error(data.message)
    } else if (typeof data === 'string') {
      throw new Error(data)
    } else if (data.non_field_errors) {
      throw new Error(data.non_field_errors[0])
    } else {
      // Si hay errores específicos de campo, mostrarlos
      const fieldErrors = Object.entries(data)
        .filter(([key]) => key !== 'detail' && key !== 'message')
        .map(([key, value]) => `${key}: ${value}`)
      if (fieldErrors.length > 0) {
        throw new Error(fieldErrors.join(', '))
      }
      throw new Error('Error en la operación')
    }
  } else if (error.request) {
    throw new Error('No se pudo conectar con el servidor')
  } else {
    throw new Error('Error al procesar la solicitud')
  }
} 
